module.exports = __webpack_public_path__ + "img/musics.3eae3cb8.png";